import request from "../../../helpers/request";
import { getUser } from "../../../helpers/user";

const getLojaById = async (idLoja: string) => {
    
  const url = `${process.env.REACT_APP_API}/Loja/${idLoja}`;

  try {
    const result = await request({ url })
    return result;
  } catch (err) {
    throw err
  }
}
export default getLojaById